import { SHARED_REACT_QUERY_CONFIG } from "../../../constants/reactQuery.constant";
import { getAdjustClause } from "../../../services/policy/policy.service";

export const ADJUST_CLAUSE = "adjustClause";
export const ADJUST_CLAUSE_CONFIG = SHARED_REACT_QUERY_CONFIG;

export const adjustClauseQuery = async ({ queryKey }: any) => {
    const params = queryKey[1];
    const request = await getAdjustClause(params.policy_id, params.vehicle_id);
    return request.data;
  };